import React, { PureComponent } from "react";
import {
  Row,
  Col,
  Badge,
  // , Input
} from "reactstrap";
import PropTypes from "prop-types";
import gql from "graphql-tag";

import ItemDetails from "../common/ItemDetails";
// import Button from "../common/Button";

import { storeCategories } from "../../utils/constants";

export class StoreInfo extends PureComponent {
  static propTypes = {
    store: PropTypes.object.isRequired,
  };

  static fragments = {
    storeDetails: gql`
      fragment StoreDetails on Store {
        id
        name
        vat
        siret
        deliveryMode
        driversMode
        rib
        acceptCGV
        nidFront
        nidBack
        siretDoc
        contract
        code
        address {
          address
        }
        contact {
          tel
          email
        }
        kitchenCategory {
          name
        }
        storeType {
          authorizeAddons
          authorizeMenuManagement
        }
        storeCategory
      }
    `,
  };

  render() {
    const { store } = this.props;

    return (
      <React.Fragment>
        <div className="ml-4">
          <div className="row col-6 d-flex justify-content-between align-items-center">
            <h4 className="bold">
              Partenaire Pro{" "}
              <Badge color={"secondary"} style={{ width: "unset" }}>
                {store.code}
              </Badge>
            </h4>
          </div>
          <Row>
            <Col sm={6} xs={12} className="NoPad2">
              <ItemDetails
                label="Nom du partenaire"
                value={store.name}
                valueClassName="text-capitalize"
              />
            </Col>
            <Col sm={6} xs={12} className="NoPad2">
              <ItemDetails
                label="tva"
                value={store.vat}
                valueClassName="text-capitalize"
              />
            </Col>
            {store.address && store.address.address && (
              <Col sm={6} xs={12} className="NoPad2">
                <ItemDetails
                  label="adresse"
                  value={store.address.address}
                  valueClassName="text-capitalize"
                />
              </Col>
            )}
            <Col sm={6} xs={12} className="NoPad2">
              <ItemDetails
                label="siret"
                value={store.siret}
                valueClassName="text-capitalize"
              />
            </Col>
            <Col sm={6} xs={12} className="NoPad2">
              <ItemDetails
                label="cuisine"
                value={store.kitchenCategory.name}
                valueClassName="text-capitalize"
              />
            </Col>
            <Col sm={6} xs={12} className="NoPad2">
              <ItemDetails
                label="type"
                value={storeCategories[store.storeCategory]}
                valueClassName="text-capitalize"
              />
            </Col>
            {store.contact && store.contact.tel && (
              <Col sm={6} xs={12} className="NoPad2">
                <ItemDetails
                  label="téléphone"
                  value={store.contact.tel}
                  valueClassName="text-capitalize"
                />
              </Col>
            )}
            {store.contact && store.contact.email && (
              <Col sm={6} xs={12} className="NoPad2">
                <ItemDetails label="email" value={store.contact.email} />
              </Col>
            )}

            {/* <Col sm={6} xs={12}>
            <ItemDetails label="rib">
              <div className="d-flex ml-10">
                <Input
                  disabled={store.rib ? true : false}
                  type="text"
                  style={{ minWidth: 160 }}
                  value={store.rib}
                />
                <Button
                  disabled={store.rib ? true : false}
                  style={{ marginLeft: 2 }}
                  color="warning"
                >
                  <div className="d-flex">
                    ENVOYER
                    <img style={{ marginLeft: 15 }} src="./images/send.png" />
                  </div>
                </Button>
              </div>
            </ItemDetails>
          </Col>
        */}
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default StoreInfo;
